import React, { Component } from "react"
import { Button, Menu, Input, Icon, DatePicker, Pagination, Affix, Checkbox, Row, Modal, Select, Dropdown } from "antd"
import ReportCard from "app/components/normal/pgs/ReportCard"
import reportIcon from "app/styles/images/sp/report-selected.svg"
import "./Index.scss"
import moment from "moment"
import queryString from 'query-string'
import { observer, Provider, inject } from "mobx-react"
import TransferModal from "./TransferModal"
import ExportGroupModal from "./ExportGroupModal"
import ExportGroupDotplot from "./ExportGroupDotplot"
import Store from "app/stores/pgs/report"
import ReportDetail from "app/components/normal/pgs/ReportDetail"
import CnvReadDetail from "app/components/normal/pgs/CnvReadDetail"
const RangePicker = DatePicker.RangePicker
import { Route } from 'react-router-dom'

const { Search } = Input

@inject('entrance', 'auth') @observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      currentPageIndex: 1,
      isHistory: "查看历史数据",
      dateValue: null,
      checkDateValue: null,
      tableData: [],
      totalCount: 0,
      showCreateNewGroup: false,
      showBatchExportGroup: false,
      showBatchExportLink: false,
      showBatchExportDotplot:false,
      reportGroupData: {},
      searchType: 'keywords',
      app: "0",              //头部筛选选中的状态 计算
      belong: "all",         //头部筛选选中的状态 自己 分享
      dayKey: "-1",           //头部筛选选中的状态 日期
      state: "all"
    }
  }

  componentWillReceiveProps(nextProps) {
    const { searchType } = this.state
    const { location } = this.props
    const { location: nextLocation } = nextProps
    if (nextLocation.search && queryString.parse(nextLocation.search).holdData) {
      return
    }

    if (nextLocation.search !== location.search) {
      const searchObj = queryString.parse(nextLocation.search)
      this.setState({
        inputSearch: searchObj[`${searchType}`]
      })
      if (nextLocation.search) {
        this.loadLimitedData(searchObj)
      } else {
        this.loadAllData()
      }
    }
  }

  loadLimitedData(queryObj) {
    const { location } = this.props
    const { holdData } = queryString.parse(location.search)
    return this.store.list.filterData(queryObj, holdData ? 'notInitPage' : undefined)
  }

  loadAllData() {
    const { list } = this.store
    return list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
        }
      )
  }

  onDataChange = (e, type) => {
    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onBelongChange = (e) => {
    this.setState({
      belong: e.key,
    })
    let { list: { filterData } } = this.store

    filterData({ belong: e.key })
  }

  onAppChange = (e) => {
    this.setState({
      app: e.key,
    })
    let { list: { queryMap } } = this.store
    let appQueryValue = null
    let isHistory = ""
    if (e.key === 0 || e.key === "0") {
      appQueryValue = null
      isHistory = "查看历史数据"
    } else if (e.key === "app_id_999" && queryMap.app === "999") {
      isHistory = "查看历史数据"
      appQueryValue = null
    } else if (e.key === "app_id_999" && (queryMap.app !== "999" || queryMap.app === null)) {
      isHistory = "关闭历史数据"
      appQueryValue = "999"
    } else {
      let appIdString = (e.key).replace("app_id_", "")
      appQueryValue = appIdString
      isHistory = "查看历史数据"
    }
    this.setState({
      isHistory,
      appQueryValue
    })

    const { history, match } = this.props
    const { inputSearch } = this.state

    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({ // 此处不可以使用 beautifyObj，不传 keywords 会导致本次查询复用上次的 keywords(此处可拓展其他字段)
        keywords: inputSearch,
        app: appQueryValue
      })
    })
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }

  searchData = () => {
    const { match, history } = this.props
    const { searchType } = this.state
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({
        [`${searchType}`]: this.state.inputSearch,
        app: this.state.appQueryValue
      })
    })
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap, filterData } } = this.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({
      dateValue: dateValue
    })
    if (!dateValue.length) {
      filterData()
    }
  }

  dateChangeOk = () => {
    let {
      list: { filterData, queryMap }
    } = this.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  checkDateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap, filterData } } = this.store
    updateQueryMap({ approveStart: dateString[0], approveEnd: dateString[1] })
    this.setState({
      checkDateValue: dateValue
    })
    if (!dateValue.length) {
      filterData()
    }
  }

  checkDateChangeOk = () => {
    let {
      list: { filterData, queryMap }
    } = this.store
    filterData({ approveEnd: moment(queryMap.approveEnd, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  componentDidMount() {
    const { list } = this.store
    const { location } = this.props

    list.getApps('common', { filter: 'used' });
    (() => {
      if (location.search) {
        const searchObj = queryString.parse(location.search)
        this.setState({
          inputSearch: searchObj.keywords
        })
        return this.loadLimitedData(searchObj)
      } else {
        return this.loadAllData()
      }
    })().then(() => {
      const pathArr = location.pathname.split('/')
      const reportId = pathArr.slice(-1)[0]
      if (pathArr.slice(-2)[0] === 'detail') {
        this.initDetailData(reportId)
      }
      if (pathArr.slice(-2)[0] === 'cnv') {
        this.initDetailData(reportId)
      }
    })
  }

  onShowSizeChange = (current, pageSize) => {
    const { list: { filterData } } = this.store

    filterData({ limit: pageSize })
  }

  onPaginChange = selectedPageNumber => {
    let {
      list
    } = this.store

    list.changePagin(selectedPageNumber)
    document.getElementById("contentTop").scrollIntoView(true)
  }

  disabledDate = (current) => {
    return current && current.valueOf() > Date.now()
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  /**
   * 只会在刷新页面的时候调用
   **/
  initDetailData = (reportId) => {
    const { getDetailData, list: { tableData } } = this.store

    let reportGroupData = tableData.find(
      data => {
        let index = data.reportList.findIndex(report => report.reportId === reportId)
        if (index > -1) {
          this.setState({
            dataIndex: index
          })
        }
        return index > -1
      }
    )

    this.setState({ reportGroupData })

    getDetailData(reportId)
  }

  dataSwitch = (index, record) => {
    let { getDetailData, clearDetailData } = this.store

    clearDetailData()

    this.setState({
      dataIndex: index,
    })

    getDetailData(record.reportId)
      .then(res => {
        record.isRead = true
      })
  }

  openReportDetail = (data, record,type) => {
    let { getDetailData, clearDetailData } = this.store
    let { history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index,
      reportGroupData: data
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
      if(type==2){
        var pathname=`${match.url}/cnv/${reportId}`
      }else{
        var pathname=`${match.url}/detail/${reportId}`
      }
    history.push({
      pathname: pathname,
      search: queryString.stringify({ // 此处不可以使用 beautifyObj，不传 keywords 会导致本次查询复用上次的 keywords(此处可拓展其他字段)
        holdData: true
      })
    })
  }

  onStateChange = (e) => {
    const {
      list: { filterData }
    } = this.store
    this.setState({
      state: e.key,
    })
    filterData({ state: e.key === 'all' ? '' : e.key })
  }

  render() {
    const { list: { tableData, totalCount, currentPageIndex, queryMap }, detailData } = this.store
    const { match, history, entrance } = this.props
    const { reportGroupData, dataIndex } = this.state
    let tmp = this.store.detailData
    let templates = entrance.templates

    return (
      <Provider store={this.store}>
        <div className="pgs report-page">
          <h2 className="page-title"><img alt="" src={reportIcon} />报告列表</h2>
          {this.renderHeader()}
          <div className="report-card-wrap">
            {tableData.map((data, index) =>
              <ReportCard
                key={data.groupId + "_groupId"}
                data={data}
                onOpenDetail={this.openReportDetail}
                gorupIndex={index}
                store={this.store}
              />
            )}
          </div>
          <div className="pagin-bottom">
            <Pagination
              showSizeChanger
              pageSize={queryMap.limit}
              onShowSizeChange={this.onShowSizeChange}
              onChange={this.onPaginChange}
              defaultCurrent={1}
              current={currentPageIndex}
              total={totalCount} />
          </div>
          {/* 报告详情modal */}
          <Route
            path={`${match.url}/detail/:id`}
            render={() => {
              return (
                <Modal
                  title="报告详情"
                  width={1172}
                  footer={0}
                  maskClosable={false}
                  visible={true}
                  onCancel={history.goBack}
                  className="detail-modal"
                >
                  <ReportDetail
                    data={reportGroupData}
                    index={dataIndex}
                    detailData={detailData}
                    reportList={reportGroupData.reportList}
                    templates={templates}
                    dataSwitch={this.dataSwitch}
                    store={this.store}
                    groupId={reportGroupData.groupId}
                  />
                </Modal>
              )
            }}
          />
          {/* cnv报告详情modal */}
          <Route
            path={`${match.url}/cnv/:id`}
            render={() => {
              return (
                <Modal
                  title="cnv报告详情"
                  width={1172}
                  footer={0}
                  maskClosable={false}
                  visible={true}
                  onCancel={history.goBack}
                  className="detail-modal"
                >
                  <CnvReadDetail
                    data={reportGroupData}
                    index={dataIndex}
                    detailData={detailData}
                    reportList={reportGroupData.reportList}
                    templates={templates}
                    dataSwitch={this.dataSwitch}
                    store={this.store}
                    groupId={reportGroupData.groupId}
                  />
                </Modal>
              )
            }}
          />
          {this.state.showCreateNewGroup &&
            <TransferModal
              onClose={() => this.closeModal("showCreateNewGroup")}
              store={this.store}
            />
          }
          {
            this.state.showBatchExportGroup && (
              <ExportGroupModal
                onClose={() => this.closeModal("showBatchExportGroup")}
                store={this.store}
                tableData={tableData}
                templates={templates}
                type="group"
              />
            )
          }
          {
            this.state.showBatchExportLink && (
              <ExportGroupModal
                onClose={() => this.closeModal("showBatchExportLink")}
                store={this.store}
                tableData={tableData}
                type="link"
              />
            )
          }
           {
            this.state.showBatchExportDotplot && (
              <ExportGroupDotplot
                onClose={() => this.closeModal("showBatchExportDotplot")}
                store={this.store}
                // tableData={tableData}
                type="Dotplot"
              />
            )
          }
        </div>
      </Provider>
    )
  }

  showCreateNewGroup = () => {
    // 拉数据
    this.setState({
      showCreateNewGroup: true
    })
  }

  showModal = (filed) => {
    this.setState({
      [filed]: true
    })
  }

  toggleUnread = (e) => {
    const { list } = this.store

    list.filterData({ unread: e.target.checked })
  }

  searchTypeChange = (e) => {
    const { list: { queryMap } } = this.store
    this.setState({
      searchType: e,
      inputSearch: ''
    })
    queryMap[this.state.searchType] = ''
    this.refs.pgsSearchInput.input.focus()
  }

  renderHeader = () => {
    const { inputSearch } = this.state
    const { userInfo } = this.props.auth
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}>
        <div className="affix-back">
          <div className="first-line">
            {this.renderUserMenu()}
            {this.renderDayMenu()}
          </div>
          {this.renderAppMenu()}
          <div className="report-search-bar">
            <Row type="flex" justify="space-between" align="middle" className="content">
              <Row type="flex" align="middle">
                <div className="search-input">
                  <Select
                    defaultValue="keywords"
                    onChange={this.searchTypeChange}
                  >
                    <Select.Option value="keywords">按关键字</Select.Option>
                    <Select.Option value="filename">按文件名</Select.Option>
                    <Select.Option value="sampleName">按样本名</Select.Option>
                    <Select.Option value="groupName">按家系名</Select.Option>
                    <Select.Option value="username">按数据来源</Select.Option>
                  </Select>
                  <Search
                    placeholder="请输入关键字搜索"
                    size="default"
                    value={inputSearch}
                    onChange={this.changeSearch}
                    ref="pgsSearchInput"
                    onSearch={this.searchData}
                  />
                </div>
                <div className="history">
                  <Button type={this.state.isHistory === "查看历史数据" ? "dashed" : "solid"}
                    onClick={() => this.onAppChange({ key: "app_id_999" })}>{this.state.isHistory}</Button>
                </div>
                <div className="unread-btn">
                  <Checkbox onChange={this.toggleUnread} >只看未读</Checkbox>
                </div>
                {(userInfo.id === '64' || userInfo.id === '1007' || userInfo.id === '1024') && (
                  <div className="auditState">
                    <Menu
                      onClick={e => this.onStateChange(e)}
                      selectedKeys={[this.state.state]}
                      mode="horizontal"
                      key="menu_date_0"
                    >
                      <Menu.Item key="all">
                        <Icon type="cloud-o" />全部
                      </Menu.Item>
                      <Menu.Item key="3">
                        已审核
                      </Menu.Item>
                      <Menu.Item key="2">
                        已保存
                      </Menu.Item>
                      <Menu.Item key="1">
                        未审核
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </Row>
              <Row>
                <div className="create-group-btn">
                  {(userInfo.id === '25')&&(
                    <Button onClick={() => this.showModal('showBatchExportDotplot')}>
                      <Icon type="arrow-down" />导出点图
                    </Button>
                  )}
                  <Button onClick={() => this.showModal('showBatchExportLink')}>
                    <Icon type="arrow-down" />导出链接
                  </Button>
                  <Button onClick={() => this.showModal('showBatchExportGroup')}>
                    <Icon type="arrow-down" />导出组报告
                  </Button>
                  <button onClick={this.showCreateNewGroup}><Icon type="plus" />新建报告组</button>
                </div>
              </Row>
            </Row>
          </div>
        </div>
      </Affix>
    )
  }

  renderUserMenu = () => {
    return (
      <div className="user-menu">
        <Menu
          className="menu-all" onClick={e => this.onDataChange(e, "belong")}
          key="menu_share_0"
          selectedKeys={[this.state.belong]}
          mode="horizontal">
          <Menu.Item key="all">
            <Icon type="cloud-o" />全部
          </Menu.Item>
          <Menu.Item key="self">
            <Icon type="team" />自己的
          </Menu.Item>
          <Menu.Item key="share">
            <Icon type="share-alt" />分享而来
          </Menu.Item>
        </Menu>
      </div>
    )
  }

  renderAppMenu = () => {
    const { list: { apps } } = this.store
    let sliceApps
    let remainApps
    if (apps.length > 6) {
      sliceApps = apps.slice(0, 6)
      remainApps = apps.slice(6)
    }

    const menu = (
      <Menu
        selectedKeys={[this.state.app]}
        onClick={e => this.onDataChange(e, "app")}
      >
        {remainApps && remainApps.map(remain => (
          <Menu.Item key={"app_id_" + remain.id} title={remain.name}>
            {remain.name}
          </Menu.Item>
        ))}
      </Menu>
    )

    return (
      <div className="menu-app-div menu-pgs-div">
        <Menu
          className="menu-app"
          onClick={e => this.onDataChange(e, "app")}
          selectedKeys={[this.state.app]}
          key="menu_app_0"
          mode="horizontal">
          <Menu.Item key="0">
            <Icon type="calculator" />全部计算
          </Menu.Item>
          {sliceApps && (
            sliceApps.map((item, index) =>
              <Menu.Item key={"app_id_" + item.id} title={item.name}>
                {item.name}
              </Menu.Item>)
          )}
          {!sliceApps && (
            apps.map((item, index) =>
              <Menu.Item key={"app_id_" + item.id} title={item.name}>
                {item.name}
              </Menu.Item>)
          )}
          {apps.length > 6 && (
            <Dropdown overlay={menu}>
              <a className="ant-dropdown-link" href="#">
                <Icon type="down" />
              </a>
            </Dropdown>
          )}
        </Menu>
      </div>
    )
  }

  renderDayMenu = () => {
    return (
      <div className="report-search-time-bar">
        {/* <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu> */}
        <div className="report-search-title">创建时间：</div>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
        <div className="report-search-title">审核时间：</div>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.checkDateValue}
          onChange={this.checkDateChange}
          onOk={this.checkDateChangeOk}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/report/index.js